module.exports = __webpack_public_path__ + "static/media/Acrilico (23).e0b0cc7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (23).jpg
// module id = 291
// module chunks = 0